export default "__VITE_ASSET__IkfAJOsr__"